const state = {
    active: 1,
    navHeight: 0,
    isPc: true
};

const mutations = {
    TOGGLE_ACTIVE: (state, active) => {
        state.active = active;
    },
    NAV_HEIGHT: (state, navHeight) => {
        state.navHeight = navHeight;
    },
    IS_PC: (state, isPc) => {
        state.isPc = isPc;
    }
};

const actions = {
    toggleActive({ commit }, active) {
        commit('TOGGLE_ACTIVE', active);
    },
    navHeight({ commit }, navHeight) {
        commit('NAV_HEIGHT', navHeight);
    },
    isPc({ commit }, isPc) {
        commit('IS_PC', isPc);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};